import sdl from '@jds/react-generated-sdl/JDSDivider';
import type { JDSDividerProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic, DividerProps } from '../logic';

const Component = (props: DividerProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    orientation = 'horizontal',
    variant = 'default',
    padPosition = 'all',
    pad = 'small',
    _ariaLabel = props.label?.toString(),
    _ariaOrientation = props.orientation?.toString(),
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    {
      orientation,
      variant,
      padPosition,
      pad,
      _ariaLabel,
      _ariaOrientation,
      ...rest
    },
    'JDSDivider',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const Divider = withLogic(Component) as React.FC<DividerProps> & {
  slotName?: string;
};

Divider.displayName = 'Divider';
Divider.slotName = 'jds_divider';

export { Divider, type JDSDividerProps };
